import { useDispatch } from 'store/hooks';
import { portfolioSetActiveInputActionAsync } from './thunks';
import { useCallback } from 'react';
import { ActiveInputType } from 'portfolio/PortfolioState';
import { clearActivePortfolioSelectionAsync } from './thunks';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'store/store';
import State from 'store/State';
import { PortfolioSelection } from 'portfolio/PortfolioSelection';
import { selectPortfolioSelection } from 'portfolio/store/selectors';
import { PortfolioSelectionWrapper } from 'portfolio/PortfolioSelectionWrapper';
import { portfolioSetSelection } from 'portfolio/store/actions';
import { useServices } from 'app/hooks';

export const useDispatchClearActivePortfolioSelection = () => {
    const dispatch = useDispatch();
    return useCallback(
        () => dispatch(clearActivePortfolioSelectionAsync()),
        [dispatch]
    );
};

export const useDispatchCurrentInputSelection = () => {
    const { portfolioService } = useServices();
    return useCallback(
        () => portfolioService.dispatchCurrentInputSelection(),
        [portfolioService]
    );
};

export const useDispatchPortfolioSetActiveInput = () => {
    const dispatch = useDispatch();
    return useCallback(
        (activeInputType: ActiveInputType) =>
            dispatch(portfolioSetActiveInputActionAsync(activeInputType)),
        [dispatch]
    );
};

export function dispatchSetPortfolioSelectionIfChanged(
    state: State,
    dispatch: ThunkDispatch<AnyAction>,
    nextSelectionState: PortfolioSelection
) {
    const previousSelectionState = selectPortfolioSelection(state);
    const previousSelection = new PortfolioSelectionWrapper(
        previousSelectionState
    );

    const nextSelection = new PortfolioSelectionWrapper(nextSelectionState);

    const ordersSelectionDiffers =
        nextSelection.orderSelectionDiffersFrom(previousSelection);
    const positionSelectionDiffers =
        nextSelection.positionSelectionDiffersFrom(previousSelection);
    const symbolQuantitySelectionDiffers =
        nextSelection.symbolQuantitySelectionDiffersFrom(previousSelection);
    const symbolSelectionDiffers =
        nextSelection.symbolSelectionDiffersFrom(previousSelection);

    if (
        ordersSelectionDiffers ||
        positionSelectionDiffers ||
        symbolQuantitySelectionDiffers ||
        symbolSelectionDiffers
    ) {
        dispatch(portfolioSetSelection(nextSelectionState));
    }
}
